<template>
  <div class="home">
    <b-container class="homeContainer">
        <!-- <b-row>
          <b-col class="colClass">
              <div class="RolexSection">
                <iframe :src="'https://wp-ocssport.ocs-sport.com/aus-js/html/golf_aus_pga_HTML_300x75/rolex.html?id=' + season + '&name=' + namecourse + '&timediff=' + timediff + '&code=' + codeRolex + '&until=' + until + '&tour=aus'" style="width:100%;height:75px;border:0;margin:0;padding:0;overflow:hidden;scroll:none" SCROLLING=NO frameborder="NO"></iframe>
              </div>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col lg='12' md='12' cols='12' class="mobileWidth">
              <div class="homeReport-list HomehomeReport-list homeHeight" :style="{height: NewWidgetHeight, 'min-height' : NewMinheight, 'max-height' : NewMaxheight }" :class="{mobWidgetPad: mobWidget == 'Y'}">
                <template v-if="showTabs">
                  <template v-if="allData != ''">
                    <b-tabs content-class="test" >
                      <template v-if="currentReport.includes('result')">
                        <b-tab title="Leaderboard" id="onetab" title-item-class="tabsStyle tabone" active >
                          <!-- <b-form-select v-model="class_api" class="textPos"  v-on:change="changeTournament(class_api)" v-if="show == true">  -->
                          <div class="TournDrop" v-if="show == true || multi_tourns == 'Y'">
                            <template v-if="multi_tourns == 'Y'">
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'"> 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :class="{showNone : allData.short_name == past.name}"
                                >
                                  {{ past.name }}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :title="past.name"
                                  >
                                    {{past.name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                            <template v-else>
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'" > 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(value,
                                  index) in smallListTours"
                                  :key="index"
                                  :value="value.Code"
                                  :class="{showNone : allData.short_name == value.Name}"
                                >
                                  {{value.Name}}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in smallListTours"
                                  :key="index" 
                                  :value="past.Code"
                                  :title="past.Name"
                                  >
                                    {{past.Name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                          </div>
                          <template v-if="this.runData == 'Y'">
                              <!-- Change Tourn  -->
                              <ReportHomeTab
                                :data="data"
                                :Year="season"
                                :code="course"
                                :course_code="course_code"
                                :reportURL="currentReport"
                                :currentReport="reportTitle"
                                :title="currentTitle"
                                :config="config"
                                :home="home"
                                :tournDates="tournDates"
                                :updateSize="updateSize"
                                :widgetHeight="widgetHeight"
                                :reports="reports"
                                :tourCode="tourCode"
                                :show="show"
                                :runData="runData"
                                :match="'N'"
                                :listFinalAll="listFinalAll"
                                :multi_tourns="multi_tourns"
                                :smallListTours="smallListTours"
                                :nameTourn="name"
                                :sponsorLogo="sponsorLogo"
                                :roundPlayed="roundPlayed"
                                :nameWomen="nameWomen"
                                :wpgaOnly="wpgaOnly"
                                :reptour="reptour"
                                :is_qualifier="is_qualifier"
                              />
                              <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                                <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, }">
                                  <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                                </div>
                              </template>
                              <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                                <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, }">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                                </div>
                              </template>
                              <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                                <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                  <p>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </div>
                              </template>
                          </template>
                          <template v-else>
                            <!-- Orginal Tourn -->
                            <ReportHomeTab
                              :data="data"
                              :Year="season"
                              :code="course"
                              :course_code="course_code"
                              :reportURL="currentReport"
                              :currentReport="reportTitle"
                              :title="currentTitle"
                              :config="config"
                              :home="home"
                              :tournDates="tournDates"
                              :updateSize="updateSize"
                              :widgetHeight="widgetHeight"
                              :reports="reports"
                              :tourCode="tourCode"
                              :show="show"
                              :runData="runData"
                              :match="'N'"
                              :listFinalAll="listFinalAll"
                              :multi_tourns="multi_tourns"
                              :smallListTours="smallListTours"
                              :nameTourn="name"
                              :sponsorLogo="sponsorLogo"
                              :roundPlayed="roundPlayed"
                              :nameWomen="nameWomen"
                              :wpgaOnly="wpgaOnly"
                              :reptour="reptour"
                              :is_qualifier="is_qualifier"
                            />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                        </b-tab>
                      </template>
                      <template v-else>
                        <b-tab title="This Week" id="onetab" title-item-class="tabsStyle tabone" active >
                          <!-- <b-form-select v-model="class_api" class="textPos"  v-on:change="changeTournament(class_api)" v-if="show == true">  -->
                          <div class="TournDrop" v-if="show == true || multi_tourns == 'Y'">
                            <template v-if="multi_tourns == 'Y'">
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'"> 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :class="{showNone : allData.short_name == past.name}"
                                >
                                  {{ past.name }}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :title="past.name"
                                  >
                                    {{past.name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                            <template v-else>
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'" > 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code + '-' + allData.class_api">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(value,
                                  index) in smallListTours"
                                  :key="index"
                                  :value="value.Code + '-' + allData.class_api"
                                  :class="{showNone : allData.short_name == value.Name}"
                                >
                                  {{value.Name}}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in smallListTours"
                                  :key="index" 
                                  :value="past.Code"
                                  :title="past.Name"
                                  >
                                    {{past.Name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                          </div>
                          <template v-if="this.runData == 'Y'">
                              <!-- Change Tourn  -->
                              <ReportHomeTab
                                :data="data"
                                :Year="season"
                                :code="course"
                                :course_code="course_code"
                                :reportURL="currentReport"
                                :currentReport="reportTitle"
                                :title="currentTitle"
                                :config="config"
                                :home="home"
                                :tournDates="tournDates"
                                :updateSize="updateSize"
                                :widgetHeight="widgetHeight"
                                :reports="reports"
                                :tourCode="tourCode"
                                :show="show"
                                :runData="runData"
                                :match="'N'"
                                :listFinalAll="listFinalAll"
                                :multi_tourns="multi_tourns"
                                :smallListTours="smallListTours"
                                :nameTourn="name"
                                :sponsorLogo="sponsorLogo"
                                :roundPlayed="roundPlayed"
                                :nameWomen="nameWomen"
                                :wpgaOnly="wpgaOnly"
                                :reptour="reptour"
                                :is_qualifier="is_qualifier"
                              />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <!-- Orginal Tourn added -->
                            <ReportHomeTab
                              :data="data"
                              :Year="season"
                              :code="course"
                              :course_code="course_code"
                              :reportURL="currentReport"
                              :currentReport="reportTitle"
                              :title="currentTitle"
                              :config="config"
                              :home="home"
                              :tournDates="tournDates"
                              :updateSize="updateSize"
                              :widgetHeight="widgetHeight"
                              :reports="reports"
                              :tourCode="tourCode"
                              :show="show"
                              :runData="runData"
                              :match="'N'"
                              :listFinalAll="listFinalAll"
                              :multi_tourns="multi_tourns"
                              :smallListTours="smallListTours"
                              :nameTourn="name"
                              :sponsorLogo="sponsorLogo"
                              :roundPlayed="roundPlayed"
                              :nameWomen="nameWomen"
                              :wpgaOnly="wpgaOnly"
                              :reptour="reptour"
                              :is_qualifier="is_qualifier"
                            />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                        </b-tab>
                      </template>
                      <b-tab title="Upcoming" title-item-class="tabsStyle tabtwo" classActive>
                        <UpcomingReportSelect :season="season" />
                      </b-tab>
                      <b-tab title="Results" title-item-class="tabsStyle tabthree">
                        <ResultsReportSelect :season="season"/>
                      </b-tab>
                    </b-tabs>
                  </template>
                  <template v-else>
                    <b-tabs content-class="test" >
                      <b-tab title="Upcoming" title-item-class="tabsStyle tabWidth" classActive active>
                        <UpcomingReportSelect :season="season"/>
                      </b-tab>
                      <b-tab title="Results" title-item-class="tabsStyle tabWidth">
                        <ResultsReportSelect :season="season"/>
                      </b-tab>
                    </b-tabs>
                  </template> 
                </template>
                <template v-else>
                  <template v-if="allData != ''">
                    <b-tabs content-class="test" >
                      <template v-if="currentReport.includes('result')">
                        <b-tab title="Leaderboard" id="onetab" title-item-class="tabsStyle tabone" active >
                          <!-- <b-form-select v-model="class_api" class="textPos"  v-on:change="changeTournament(class_api)" v-if="show == true">  -->
                          <div class="TournDrop" v-if="show == true || multi_tourns == 'Y'">
                            <template v-if="multi_tourns == 'Y'">
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'"> 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :class="{showNone : allData.short_name == past.name}"
                                >
                                  {{ past.name }}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :title="past.name"
                                  >
                                    {{past.name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                            <template v-else>
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'" > 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(value,
                                  index) in smallListTours"
                                  :key="index"
                                  :value="value.Code"
                                  :class="{showNone : allData.short_name == value.Name}"
                                >
                                  {{value.Name}}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in smallListTours"
                                  :key="index" 
                                  :value="past.Code"
                                  :title="past.Name"
                                  >
                                    {{past.Name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                          </div>
                          <template v-if="this.runData == 'Y'">
                              <!-- Change Tourn  -->
                              <ReportHomeTab
                                :data="data"
                                :Year="season"
                                :code="course"
                                :course_code="course_code"
                                :reportURL="currentReport"
                                :currentReport="reportTitle"
                                :title="currentTitle"
                                :config="config"
                                :home="home"
                                :tournDates="tournDates"
                                :updateSize="updateSize"
                                :widgetHeight="widgetHeight"
                                :reports="reports"
                                :tourCode="tourCode"
                                :show="show"
                                :runData="runData"
                                :match="'N'"
                                :listFinalAll="listFinalAll"
                                :multi_tourns="multi_tourns"
                                :smallListTours="smallListTours"
                                :nameTourn="name"
                                :sponsorLogo="sponsorLogo"
                                :roundPlayed="roundPlayed"
                                :nameWomen="nameWomen"
                                :wpgaOnly="wpgaOnly"
                                :reptour="reptour"
                                :is_qualifier="is_qualifier"
                              />
                              <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                                <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, }">
                                  <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                                </div>
                              </template>
                              <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                                <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, }">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                                </div>
                              </template>
                              <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                                <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                  <p>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </div>
                              </template>
                          </template>
                          <template v-else>
                            <!-- Orginal Tourn -->
                            <ReportHomeTab
                              :data="data"
                              :Year="season"
                              :code="course"
                              :course_code="course_code"
                              :reportURL="currentReport"
                              :currentReport="reportTitle"
                              :title="currentTitle"
                              :config="config"
                              :home="home"
                              :tournDates="tournDates"
                              :updateSize="updateSize"
                              :widgetHeight="widgetHeight"
                              :reports="reports"
                              :tourCode="tourCode"
                              :show="show"
                              :runData="runData"
                              :match="'N'"
                              :listFinalAll="listFinalAll"
                              :multi_tourns="multi_tourns"
                              :smallListTours="smallListTours"
                              :nameTourn="name"
                              :sponsorLogo="sponsorLogo"
                              :roundPlayed="roundPlayed"
                              :nameWomen="nameWomen"
                              :wpgaOnly="wpgaOnly"
                              :reptour="reptour"
                              :is_qualifier="is_qualifier"
                            />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                        </b-tab>
                      </template>
                      <template v-else>
                        <b-tab title="This Week" id="onetab" title-item-class="tabsStyle tabone" active >
                          <!-- <b-form-select v-model="class_api" class="textPos"  v-on:change="changeTournament(class_api)" v-if="show == true">  -->
                          <div class="TournDrop" v-if="show == true || multi_tourns == 'Y'">
                            <template v-if="multi_tourns == 'Y'">
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'"> 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :class="{showNone : allData.short_name == past.name}"
                                >
                                  {{ past.name }}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :title="past.name"
                                  >
                                    {{past.name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                            <template v-else>
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'" > 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code + '-' + allData.class_api">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(value,
                                  index) in smallListTours"
                                  :key="index"
                                  :value="value.Code + '-' + allData.class_api"
                                  :class="{showNone : allData.short_name == value.Name}"
                                >
                                  {{value.Name}}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in smallListTours"
                                  :key="index" 
                                  :value="past.Code"
                                  :title="past.Name"
                                  >
                                    {{past.Name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                          </div>
                          <template v-if="this.runData == 'Y'">
                              <!-- Change Tourn  -->
                              <ReportHomeTab
                                :data="data"
                                :Year="season"
                                :code="course"
                                :course_code="course_code"
                                :reportURL="currentReport"
                                :currentReport="reportTitle"
                                :title="currentTitle"
                                :config="config"
                                :home="home"
                                :tournDates="tournDates"
                                :updateSize="updateSize"
                                :widgetHeight="widgetHeight"
                                :reports="reports"
                                :tourCode="tourCode"
                                :show="show"
                                :runData="runData"
                                :match="'N'"
                                :listFinalAll="listFinalAll"
                                :multi_tourns="multi_tourns"
                                :smallListTours="smallListTours"
                                :nameTourn="name"
                                :sponsorLogo="sponsorLogo"
                                :roundPlayed="roundPlayed"
                                :nameWomen="nameWomen"
                                :wpgaOnly="wpgaOnly"
                                :reptour="reptour"
                                :is_qualifier="is_qualifier"
                              />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <!-- Orginal Tourn added -->
                            <ReportHomeTab
                              :data="data"
                              :Year="season"
                              :code="course"
                              :course_code="course_code"
                              :reportURL="currentReport"
                              :currentReport="reportTitle"
                              :title="currentTitle"
                              :config="config"
                              :home="home"
                              :tournDates="tournDates"
                              :updateSize="updateSize"
                              :widgetHeight="widgetHeight"
                              :reports="reports"
                              :tourCode="tourCode"
                              :show="show"
                              :runData="runData"
                              :match="'N'"
                              :listFinalAll="listFinalAll"
                              :multi_tourns="multi_tourns"
                              :smallListTours="smallListTours"
                              :nameTourn="name"
                              :sponsorLogo="sponsorLogo"
                              :roundPlayed="roundPlayed"
                              :nameWomen="nameWomen"
                              :wpgaOnly="wpgaOnly"
                              :reptour="reptour"
                              :is_qualifier="is_qualifier"
                            />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                        </b-tab>
                      </template>
                    </b-tabs>
                  </template>
                  <template v-else>
                    <b-tabs content-class="test" >
                      <b-tab title="Upcoming" title-item-class="tabsStyle tabWidth" classActive active>
                        <UpcomingReportSelect :season="season"/>
                      </b-tab>
                      <b-tab title="Results" title-item-class="tabsStyle tabWidth">
                        <ResultsReportSelect :season="season"/>
                      </b-tab>
                    </b-tabs>
                  </template> 
                </template>
              </div>
          </b-col>
        </b-row>
        <b-row v-if="showRolex">
          <b-col class="colClass">
            <div class="RolexSection">
              <iframe
                :src="'https://wp-ocssport.ocs-sport.com/aus-js/html/golf_aus_pga_HTML_300x75/rolex.html?id='
                  + season
                  + '&name=' + namecourse
                  + '&timediff=' + timediff
                  + '&code=' + codeRolex
                  + '&until=' + until
                  + '&tour=aus'"
                style="width:100%;height:75px;border:0;margin:0;padding:0;overflow:hidden;"
                scrolling="no"
                frameborder="0">
              </iframe>
            </div>
          </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
import ReportHomeTab from "@/components/reportHometab.vue";
import UpcomingReportSelect from "@/components/UpcomingReportSelect.vue";
import ResultsReportSelect from "@/components/ResultsReportSelect.vue";
import axios from "axios";
export default {
  name: "Second Home", 
  props: ['config'],
  components: { 
    UpcomingReportSelect,
    ResultsReportSelect,
    ReportHomeTab,
  }, // Everything below on every /view/<Page Name>.vue for meta info and all ACF data
  data: function() {
    return {
      title: [], //Page Title
      description: [], //Meta Description
      homepage: true,
      home: true,
      wphome: [],
      inter: "5",
      pro: "44",
      latestsm: "29",
      latestFull: "8",
      featHome: "true",
      data: [],
      reports: [],
      course: [],
      season: [],
      course_code: [],
      tm_params:[],
      mobWidget: process.env.VUE_APP_MOB_WIDGET,
      // tourCode: '',
      tourCode: [],
      NextTournCode: [],
      text: '',
      NewWidgetHeight: '',
      NewMinheight: '',
      NewMaxheight: '',
      activeTab: '',
      scores_available: '',
      showReports: '',
      results_available: '',
      smallListTours: [],
      FullListT: [],
      show: false,
      runData: 'N',
      url: '',
      multi_tourns: '',
      finalFilter: [],
      firstArray: [],
      listFinalAll:[],
      EveryTour: [],
      switch: false,
      code: null,
      playsus: false,
      name: '',
      namecourse: '',
      timediff: '',
      until: '',
      codeRolex: '',
      updateSize: '',
      widgetHeight: '',
      upComingAus: [],
      upComingWPG: [],
      sponsorLogo: '',
      roundPlayed: '',
      nameWomen:'',
      showReport: true,
      tournamentName: '',
      reptour: '',
      wpgareports: [],
      FirstCoursecode: '', 
      courseCodeWPGA: '',
      wpgaDaysAway: '',
      wpgaOnly: 'N',
      ts_final_result: '',
      allData: [],
      combinedTours: [],
      WpgData: [],
      AusData: [],
      allAusTours: [],
      allWpgaTours: [],
      FirstCoursecodewpg: '',
      reportswpg: [],
      daysAwaywpg: '',
      tournDateswpg: '',
      tournamentNamewpg: '',
      FirstCoursecodeaus: '',
      reportsaus: [],
      daysAwayaus: '',
      tournDatesaus: '',
      tournamentNameaus: '',
      class_apiaus: '',
      class_apiwpg: '',
      wpgaCon: [],
      ausCon: [],
      is_qualifier: '',
      is_qualifierwpg:'',
      is_qualifieraus: '',
      seasonAll: ''
    };
  },
  methods: {
    updateStuffMulti: function() {
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          return axios.get(
            process.env.VUE_APP_TIC_BASE +
            'snr/' +
              this.season +
              "/" +
              this.season +
              "-" +
              this.allData.code +
              "-tmticx.json?randomaddUPDATE=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.tm_params = response.data;
        });
    },
    updateStuffMultiTour: function(code) {
      this.wpgCode = code
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          return axios.get(
            process.env.VUE_APP_TIC_BASE +
            'all/' +
              this.season +
              "/" +
              this.season +
              "-" +
              this.wpgCode +
              "-tmticx.json?randomadd=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.tm_params = response.data;
          
        });
    },
    MobileswapTour: function(event) {
      var title = event.target.getAttribute("title");
      console.log("title " + title)
      var code = event.target.getAttribute("value");
      console.log("code " + code)
      this.tournamentName = title;
      console.log("this.tournamentName " + this.tournamentName)
      this.course = code;
      console.log("this.course " + this.course)
      this.updateStuffMulti(code);
      this.getSecondTournTicx(code);
    },
    swapTour:function(code) {
      if (this.allData.code == code) {
        console.log('TRUE Y')
        this.showReport = true;
      } else {
        console.log('FALSE N')
        this.showReport = false;
      }
      this.course = code;
      // Aus Code
      // this.updateStuffMulti(code);
      // this.getSecondTournTicx(code);
      // Wpga
        this.updateStuffMultiTour(code);
        this.getTourSecondTick(code); 

    },
    getSecondTournTicx(code) {
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          console.log("this.data")
          console.log(this.data)
          return axios.get(
            process.env.VUE_APP_TIC_BASE + 
              'snr/' +
              this.season +
              "/" +
              this.season +
              "-" +
              code +
              "-tmticx.json?mattrandomadd1=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.second_tourn_tixc = response.data;
          this.reports = response.data.reports.reports_entry;
          this.tournDates = response.data.dic_dates;
          this.name = response.data.short_name
          this.namecourse = response.data.course_city;
          this.is_qualifier = response.data.is_qualifier;
          this.timediff = response.data.time_diff_dec;
          this.until = response.data.days_away;
          this.codeRolex = response.data.code;
          this.sponsorLogo = response.data.sponsor_logo;
          this.roundPlayed = response.data.rounds_played;
          this.winnerType = response.data.winner_result;
          if (typeof this.second_tourn_tixc.reports != "undefined") {
            console.log('in second tmticx')
            if (Array.isArray(this.reports)) {
              this.second_tourn_tixc.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                  this.report = element.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmdraw") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
              });
            } else {
                if (this.reports.report_url.indexOf("tmentry") !== -1) {
                  this.report = this.reports.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
            }

          }
        });
    },
    getTourSecondTick(code) {
      console.log('inTourSecond Tick')
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          return axios.get(
            process.env.VUE_APP_TIC_BASE + 
              'all/' +
              this.seasonAll +
              "/" +
              this.seasonAll +
              "-" +
              code +
              "-tmticx.json?secondTickrandomadd2=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.second_tourn_tixc = response.data;
          this.reports = response.data.reports.reports_entry;
          this.tournDates = response.data.dic_dates;
          this.namecourse = response.data.course_city;
          this.is_qualifier = response.data.is_qualifier;
          this.timediff = response.data.time_diff_dec;
          this.until = response.data.days_away;
          this.codeRolex = response.data.code;
          // this.nameWomen = response.data.short_name
          this.name = response.data.short_name
          this.sponsorLogo = response.data.sponsor_logo;
          this.roundPlayed = response.data.rounds_played;
          this.winnerType = response.data.winner_result;
          if (typeof this.second_tourn_tixc.reports != "undefined") {
            if (Array.isArray(this.reports)) {
              this.second_tourn_tixc.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMultiTour(code);
                }
                if (element.report_url.indexOf("tmdraw") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMultiTour(code);
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMultiTour(code);
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMultiTour(code);
                }
              });
            } else {
              if (this.reports.report_url.indexOf("tmentry") !== -1) {
                this.report = this.reports.report_url;
                this.updateStuffMultiTour(code);
              }
            }

          }
        });
    },
    MobileTournamentChange: function(event) {
      var title = event.target.getAttribute("title");
      console.log("title " + title)
      var code = event.target.getAttribute("value");
      console.log("code " + code)
      this.tournamentName = title;
      console.log("this.tournamentName " + this.tournamentName)
      this.course = code;
      console.log("this.course")
      console.log(this.course)
      let codeTourn = [];
      console.log("codeTourn")
      console.log(codeTourn)
      this.tourCode = codeTourn;
      this.NextTournCode = codeTourn;
      this.smallListTours.forEach((value) => {
          if (value.Code == this.course) {
            codeTourn.push(value.class_api);
          }
      }); 
      if (codeTourn[0] == 'snr') {
        this.getSecondTournTicx(code);
        this.updateStuffMulti(code);
      } else if(codeTourn[0] == 'all') {
        this.updateStuffMultiTour(code);
        this.getTourSecondTick(code); 
      } else {
        this.getSecondTournTicx(code);
        this.updateStuffMulti(code);
      }
    },
    TournamentChange(code) {
      // Set basic state
      this.course = code;
      console.log('this.course')
      console.log(this.course)

      // Toggle report visibility
      this.showReport = this.allData.code === code;
      console.log(this.showReport ? 'TRUE Y' : 'FALSE N');

      // Find matching tournament
      // const match = this.smallListTours.find(v => v.Code === code);

      // Safely get class_api
      const classApi = 'snr';

      this.tourCode = classApi;
      this.NextTournCode = classApi;

      console.log("this.course", this.course);
      console.log("classApi", classApi);

      // Handle logic based on class_api
      if (classApi === 'snr') {
        console.log('IN SNR');
        this.getSecondTournTicx(code);
        this.updateStuffMulti(code);
      }
    },

    reportListText: function() {
      if (Array.isArray(this.reports)) {
        this.activeTab = false
        this.classActive = 'active'
      } else {
        this.reports.forEach((value) => {
          if (value.report_title.includes('Score')) {
            this.activeTab = true
            this.classActive = 'active'
          } else {
            this.activeTab = false
            this.classActive = ''
          }
        });
      } 
    },
    // isMobile() {
    //   if (screen.width <= 768) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    myFunction: function() {
      let h = window.outerWidth;
      let txt = h;
      this.text = txt;
      if (this.text == 1400 || this.text > 1401) {
        // this.NewWidgetHeight = '669px!important'
        if (this.mobWidget == 'Y') {
          this.NewWidgetHeight = '300px!important' 
        } else {
          // if (this.multi_tourns == 'Y') {
          //   this.NewWidgetHeight = '570px!important'   
          //   this.NewMinheight = '570px!important'     
          //   this.NewMaxheight = '570px!important'            
          // } else {
          //   this.NewWidgetHeight = '589px!important'     
          //   this.NewMinheight = '589px!important'     
          //   this.NewMaxheight = '589px!important'                      
          // }
            this.NewWidgetHeight = '589px!important'     
            this.NewMinheight = '589px!important'     
            this.NewMaxheight = '589px!important'    
        }
      } else if(this.text == 1400 || this.text == 1397) {
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important'  
      } else if(this.text < 1400  && this.text > 1200) {
        // this.NewWidgetHeight = '555px!important'
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important'  
      } else if(this.text < 1199) {
         if (this.mobWidget == 'Y') {
          // this.NewWidgetHeight = '399px!important' 
          this.NewWidgetHeight = '399px!important' 
        } else {
          this.NewWidgetHeight = '411px!important'
          this.NewMinheight = '411px!important'     
          this.NewMaxheight = '411px!important'  
          this.playsus = true
        }
      } else if(this.text < 1400  && this.text > 1199) {
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important' 
      }
    },
    getAllTourns: function() {
      console.log('In')
      const aus = this.AusData;
      const children = aus;
      console.log("children")
      console.log(children)
      let smallListTours = [];
      console.log("smallListTours")
      console.log(smallListTours)
      this.EveryTour.forEach((value) => {
        if (value.days_away < 5 && value.ts_final_result == 'N') {
          if (!value.code) {
            console.log('In foreach 658')
            smallListTours.push(value); 
          }
        }
      }); 
      smallListTours.sort((a, b) => {
          let da = a.days_away,
              db = b.days_away;
          return da - db; 
      });

      console.log(smallListTours);
      this.smallListTours = smallListTours;
      if (this.smallListTours.length > 1) {
        this.show = true
      } else {
        this.show = false
      }
      // console.log("this.smallListTours")
      // console.log(this.smallListTours)

      // Filter Section to ssee if days away match

      //Order index 0 postion
        this.tourCode = 'snr';
        this.gettmticXData(this.tourCode)
 
    },
    getToursMulti: function() {
      console.log('in get tours')
      let tourwpg = this.allWpgaTours
      let touraus = this.allAusTours

      let allChildren = touraus.concat(tourwpg)
      console.log("allChildren")
      console.log(allChildren)

      let smallListTours = []
      console.log("smallListTours")
      console.log(smallListTours)
      allChildren.forEach((value) => {
        if (value.DaysAway == value.DaysAway) {
          smallListTours.push(value); 
        }
      });
      console.log(smallListTours);
      this.smallListTours = smallListTours;
      if (this.smallListTours.length > 1) {
        console.log('Show is true')
        this.show = true
      } else {
        console.log('Show is false')
        this.show = false
      }
    },
    gettmticXData: function() {
      axios 
      .get('https://api.aus.ocs-software.com/pgaaus/cache/' + this.tourCode + '/tmticx?randomadd=' + new Date().getTime())
      .then(({ data }) => {
        this.tm_params = data;
        this.season = data.tm_params.season_code;
        this.course = data.code;
        this.multi_tourns = data.multi_tourns;
        this.is_qualifier = data.is_qualifier;
        this.course_code = data.course_code;
        this.tournDates = data.dic_dates;
        this.name = data.short_name
        this.sponsorLogo = data.sponsor_logo;
        this.roundPlayed = data.rounds_played;
        this.scores_available = data.scores_available;
        this.ts_round_status_1 = data.ts_round_status_1;
        this.daysAway = parseInt(data.days_away);
        this.firstArray = [
          {
            'name': this.name,
            'code': this.course,
          }
        ]
        this.pastTourns = data.past_tourns;
        this.futureTourns = data.future_tourns;
        if (this.pastTourns != '') {
          if (Array.isArray(data.past_tourns.past_tourns_entry)) {
            console.log("isArray");
            this.past_tourns = data.past_tourns.past_tourns_entry;
          } else {
            console.log("is not Array");
            this.past_tourns = [data.past_tourns.past_tourns_entry];
          }
          var listFinal =  this.firstArray.concat(this.past_tourns);
          this.listFinalAll = listFinal;          
        } else if (this.futureTourns !== '') {
          if (Array.isArray(data.future_tourns.future_tourns_entry)) {
            console.log("isArray");
            this.past_tourns = data.future_tourns.future_tourns_entry;
          } else {
            console.log("is not Array");
            this.past_tourns = [data.future_tourns.future_tourns_entry];
          }
          var listFinals=  this.firstArray.concat(this.past_tourns);
          this.listFinalAll = listFinals;
        }

        // if (this.daysAway > 5 || this.results_available != '' || this.ts_round_status_1 != 'S') {
        // if (this.daysAway > 5 && this.results_available != '' && this.ts_round_status_1 != 'S' || this.ts_round_status_1 != 'C') {
        if (this.daysAway > 5) {
          this.showReports = 'N'
        } else {
          this.showReports = 'Y'
        }
        this.reports = data.reports.reports_entry;
        this.reportsStart = data.reports;
        if (this.reportsStart != '') {
          let arr = [];
          this.results_available = arr;
          if (Array.isArray(this.reports)) {
            this.reports.forEach((value) => {
                if (value.report_title.includes('Result')) {
                  arr.push(value.report_title);
                  // console.log(value); 
                }
            });  
          }
        }
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
    },
    getAusSecondTournTicx() {
      console.log('In Aus')
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          console.log("this.data")
          console.log(this.data)
          return axios.get(
            process.env.VUE_APP_TIC_BASE + 
              'snr/' +
              this.tm_params.tm_params.season_code +
              "/" +
              this.tm_params.tm_params.season_code +
              "-" +
              this.courseCodeWPGA +
              "-tmticx.json?mattrandomadd3=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.reptour = 'snr';
          this.second_tourn_tixc = response.data;
          this.reports = response.data.reports.reports_entry;
          this.tournDates = response.data.dic_dates;
          this.name = response.data.short_name;
          this.course = response.data.code;
          this.code = response.data.code;
          this.is_qualifier = response.data.is_qualifier;
          var code = this.code;
          console.log("code")
          console.log(code)
          this.sponsorLogo = response.data.sponsor_logo;
          this.roundPlayed = response.data.rounds_played;
          this.winnerType = response.data.winner_result;
          if (typeof this.second_tourn_tixc.reports != "undefined") {
            console.log('in second tmticx')
            if (Array.isArray(this.reports)) {
              this.second_tourn_tixc.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                  this.report = element.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmdraw") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
              });
            } else {
                if (this.reports.report_url.indexOf("tmentry") !== -1) {
                  this.report = this.reports.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
            }

          }
        });
    },
    getWPGASecondTournTicx() {
      console.log('In WPGA')
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          console.log("this.data")
          console.log(this.data)
          return axios.get(
            process.env.VUE_APP_TIC_BASE + 
              'all/' +
              this.tm_params.tm_params.season_code +
              "/" +
              this.tm_params.tm_params.season_code +
              "-" +
              this.FirstCoursecode +
              "-tmticx.json?4=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.reptour = 'all';
          this.second_tourn_tixc = response.data;
          this.reports = response.data.reports.reports_entry;
          this.tournDates = response.data.dic_dates;
          this.is_qualifier = response.data.is_qualifier;
          this.namecourse = response.data.course_city;
          this.timediff = response.data.time_diff_dec;
          this.until = response.data.days_away;
          this.codeRolex = response.data.code;
          this.name = response.data.short_name;
          this.course = response.data.code;
          this.code = response.data.code;
          var code = this.code;
          console.log("code")
          console.log(code)
          this.sponsorLogo = response.data.sponsor_logo;
          this.roundPlayed = response.data.rounds_played;
          this.winnerType = response.data.winner_result;
          if (typeof this.second_tourn_tixc.reports != "undefined") {
            console.log('in second tmticx')
            if (Array.isArray(this.reports)) {
              this.second_tourn_tixc.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                  this.report = element.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmdraw") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
              });
            } else {
                if (this.reports.report_url.indexOf("tmentry") !== -1) {
                  this.report = this.reports.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
            }

          }
        });
    },
    changeTournament: function(class_api) {
      this.tourCode = class_api;
      // console.log("this.tourCode")
      // console.log(this.tourCode)
      console.log('Change')
      this.runData = 'Y'
      console.log("this.runData -- Homepage")
      console.log(this.runData)
      axios 
      .get('https://api.aus.ocs-software.com/pgaaus/cache/' + this.tourCode + '/tmticx?randomadd=' + new Date().getTime())
      .then(({ data }) => {
        this.tm_params = data;
        this.season = data.tm_params.season_code;
        console.log('OnCHANGE')
        console.log(this.season)
        this.course = data.code;
        console.log("this.course")
        console.log(this.course)
        this.course_code = data.course_code;
        this.tournDates = data.dic_dates;
        this.is_qualifier = data.is_qualifier;
        this.name = data.short_name
        this.sponsorLogo = data.sponsor_logo;
        this.roundPlayed = data.rounds_played;
        this.scores_available = data.scores_available;
        this.ts_round_status_1 = data.ts_round_status_1;
        this.daysAway = parseInt(data.days_away);
        this.updateStuff()
        // if (this.daysAway > 5 || this.results_available != '' || this.ts_round_status_1 != 'S') {
        // if (this.daysAway > 5 && this.results_available != '') {
        if (this.daysAway > 5) {
          this.showReports = 'N'
        } else {
          this.showReports = 'Y'
        }
        this.reports = data.reports.reports_entry;
        this.reportsStart = data.reports;
        if (this.reportsStart != '') {
          let arr = [];
          this.results_available = arr;
          if (Array.isArray(this.reports)) {
            this.reports.forEach((value) => {
                if (value.report_title.includes('Result')) {
                  arr.push(value.report_title);
                  // console.log(value); 
                }
            });  
          }
        }
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
    },
    changeTournamentMulti: function(code) {
      this.tourCode = 'snr';
      this.course = code
      console.log('Change')
      this.runData = 'Y'
      console.log("this.runData -- Homepage")
      console.log(this.runData)
      axios 
      .get('https://api.aus.ocs-software.com/pgaaus/cache/' + this.tourCode + '/tmticx?randomadd=' + new Date().getTime())
      .then(({ data }) => {
        this.tm_params = data;
        this.season = data.tm_params.season_code;
        // this.course = data.code;
        console.log("this.course")
        console.log(this.course)
        this.course_code = data.course_code;
        this.is_qualifier = data.is_qualifier;
        this.tournDates = data.dic_dates;
        this.name = data.short_name
        this.sponsorLogo = data.sponsor_logo;
        this.roundPlayed = data.rounds_played;
        this.scores_available = data.scores_available;
        this.ts_round_status_1 = data.ts_round_status_1;
        this.daysAway = parseInt(data.days_away);
        this.updateStuff()
        // if (this.daysAway > 5 || this.results_available != '' || this.ts_round_status_1 != 'S') {
        // if (this.daysAway > 5 && this.results_available != '') {
        if (this.daysAway > 5) {
          this.showReports = 'N'
        } else {
          this.showReports = 'Y'
        }
        this.reports = data.reports.reports_entry;
        this.reportsStart = data.reports;
        if (this.reportsStart != '') {
          let arr = [];
          this.results_available = arr;
          if (Array.isArray(this.reports)) {
            this.reports.forEach((value) => {
                if (value.report_title.includes('Result')) {
                  arr.push(value.report_title);
                  // console.log(value); 
                }
            });  
          }
        }
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
    },
    FilterFinalTourns: function() {
      if (this.filterTournaments.length > 1) {
        this.FullListT = this.filterTournaments;
        let chars = this.FullListT;

        let uniqueChars = [];
        this.finalFilter = uniqueChars;
        console.log("this.finalFilter")
        console.log(this.finalFilter)
        chars.forEach((element) => {
            if (!uniqueChars.includes(element.code)) {
                uniqueChars.push({ name: element.short_name, code: element.code, });
            }
        });

        console.log("uniqueChars");
        console.log(uniqueChars);
        console.log('this.FullListT')
        console.log(this.FullListT)
        this.show = true;
      } else if(this.filterTournamentsOne.length > 1) {
        this.FullListT = this.filterTournamentsOne;
      } else if(this.filterTournamentsTwo.length > 1) {
        this.FullListT = this.filterTournamentsTwo;
        // this.show = true;
      } else if(this.filterTournamentsThree.length > 1) {
        this.FullListT = this.filterTournamentsThree;
      } else if(this.filterTournamentsFour.length > 1) {
        this.FullListT = this.filterTournamentsFour;
      } else {
        console.log('false')
      }
    },
    async updateStuff() {
      try {
        // First call, await for call to return
        // let first_call = await apiCall.tmParamsYear(this.season);
        // this.tm_params = first_call.data;
        // this.loading = false;
        // Second call, await for call to return

        if (this.multi_tourns == "Y") {
          let first_call = await apiCall.report(this.reportTitle);
          const ticx_url =
            this.config.VUE_APP_API +
            "snr" +
            "/cache/" +
            this.apiClass +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-tmticx.json?randomadd=" +
            new Date().getTime();
          let ticx_call = await apiCall.report(ticx_url);
          this.data = first_call.data;

          if (ticx_call && ticx_call.data.reports) {
            const reports = ticx_call.data.reports.reports_entry;
            if (!Array.isArray(reports)) {
              console.log('isNot Array')
            } else{
              reports.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                  this.report_url_for_report_page = element.report_url;
                  this.reports_title = element.report_title;
                  // this.updateStuff();
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.report_url_for_report_page = element.report_url;
                  this.reports_title = element.report_title;
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.report_url_for_report_page = element.report_url;
                  this.reports_title = element.report_title;
                  // this.updateStuff();
                }
              });
            }
          }
        } else {
          let first_call = await apiCall.report(this.reportTitle);
          this.data = first_call.data;
          this.loading = false;
        }
        this.loading = false;
      } catch (error) {
        console.log("error in await calls");
        console.log(error);
        throw error;
      }
    },
    getReports: function(currentReport) {
      console.log('in reports')
      apiCall
      .report(currentReport)
      .then(({ data }) => {
        this.data = data;
        console.log("this.data")
        console.log(this.data)
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
    },
    OrginalWPGATMTICX:function() {
    axios
      .get(
        'https://api.aus.ocs-software.com/pgaaus/cache/all/' +
          "tmticx?randomadd=" +
          new Date().getTime()
      )
      .then(response => {
        this.wpgaDaysAway = response.data.days_away;
        console.log("this.wpgaDaysAway" + this.wpgaDaysAway)
      })
    }
  },
  mounted() {
    axios
      .get(
        'https://api.aus.ocs-software.com/pgaaus/cache/aus/' +
          "tmticx?multi=Y&tour=snr&tour=all&days=-5&daysmax=10&randomadd=" +
          new Date().getTime()
      )
      .then(response => {
        // this.OrginalWPGATMTICX();
        if (typeof response.data.snr[0][0] !== 'undefined') {
          this.allData = response.data.snr[0][0].data;
          this.AusData = response.data.snr[0][0].data;
          this.reptour = 'snr';
          this.tm_params = this.allData.tm_params.season_code;
          this.is_qualifier = this.allData.is_qualifier;
          // this.is_qualifier = this.addData.is_qualifier;
          this.tournamentName = this.allData.short_name;
          this.multi_tourns = this.allData.multi_tourns;
          this.match = this.allData.match_play;
          this.course = this.allData.code;
          this.FirstCoursecode = this.allData.code
          this.class_api = this.allData.class_api;

          this.namecourse = this.allData.course_city;
          this.timediff = this.allData.time_diff_dec;
          this.until = this.allData.days_away;
          this.codeRolex = this.allData.code;


          this.reports = this.allData.reports.reports_entry;

          console.log("this.reports")
          console.log(this.reports)
          this.reportsStart = this.allData.reports;
          if (Array.isArray(this.reports)) {
            this.reportsArray = true;
            console.log("this.reportsArray -- true")
            console.log(this.reportsArray)
          } else {
            this.reportsArray = false;
            console.log("this.reportsArray -- false")
            console.log(this.reportsArray)
          }
          this.daysAway = parseInt(this.allData.days_away);
          this.daysAwaywpg = parseInt(response.data.all[0][0].data.days_away);
          console.log( "this.daysAway" + this.daysAway)
          this.ts_final_result = this.allData.ts_final_result;
          if (this.daysAway > 5 ) {
            this.showReports = 'N'
          } else {
            this.showReports = 'Y'
          }
            // this.getWPGAtmticXData();

          // if (this.daysAway < this.wpgaDaysAway) {
          //   console.log('In wpga')
          //   this.showReports = 'N'
          //   this.getWPGAtmticXData();
          //   this.wpgaOnly = 'Y'
          // } else {
          //   this.showReports = 'Y'
          // }
          this.season = this.allData.tm_params.season_code;
          this.course_code = this.allData.course_code;
          this.tournDates = this.allData.dic_dates;
          this.name = this.allData.short_name;
          this.sponsorLogo = this.allData.sponsor_logo;
          this.roundPlayed = this.allData.rounds_played;
          this.scores_available = this.allData.scores_available;
          this.ts_round_status_1 = this.allData.ts_round_status_1;
          this.firstArray = [
            {
              'name': this.name,
              'code': this.course,
              'tour': 'snr',
              'class_api': 'snr'
            }
          ]
          this.reports = this.allData.reports.reports_entry;
          this.reportsStart = this.allData.reports;
          this.pastTourns = this.allData.past_tourns;
          this.futureTourns = this.allData.future_tourns;
          if (this.pastTourns != '') {
            if (Array.isArray(this.allData.past_tourns.past_tourns_entry)) {
              this.past_tourns = this.allData.past_tourns.past_tourns_entry;
            } else {
              this.past_tourns = [this.allData.past_tourns.past_tourns_entry];
            }
            var listFinal =  this.firstArray.concat(this.past_tourns);
            this.listFinalAll = listFinal;          
          } else if (this.futureTourns !== '') {
            if (Array.isArray(this.allData.future_tourns.future_tourns_entry)) {
              this.past_tourns = this.allData.future_tourns.future_tourns_entry;
            } else {
              this.past_tourns = [this.allData.future_tourns.future_tourns_entry];
            }
            var listFinals=  this.firstArray.concat(this.past_tourns);
            this.listFinalAll = listFinals;
          }
          if (this.reportsStart != '') {
            let arr = [];
            this.results_available = arr;
            if (Array.isArray(this.reports)) {
              this.reports.forEach((value) => {
                  if (value.report_title.includes('Result')) {
                    arr.push(value.report_title);
                    // console.log(value); 
                  }
              });  
            }
          }

          // Multi Tours 
          const ausTours = [];
          this.allAusTours = ausTours
          console.log("austour FFS")
          console.log(ausTours)
          ausTours.push({
            "Code": this.FirstCoursecode, 
            "Name" : this.tournamentName, 
            "Reports": this.reports, 
            "DaysAway": this.daysAway,
            "Dates": this.tournDates,
            "reptour": 'snr',
            "class_api": 'snr',
          })



          this.getToursMulti();
          // End  Multi Tours 

          this.getAllTourns();

          window.addEventListener('resize', this.myFunction);
          this.myFunction();          
          // console.clear();
          this.loading = false;
        } else {
          console.log('ALL IS EMPTY')
        }
      })
  },
  computed: {
    showRolex() {
      const params = new URLSearchParams(window.location.search);
      return params.get('rolex') !== 'N';
    },
    showTabs() {
      const params = new URLSearchParams(window.location.search);
      return params.get('leaderboard') != 'O';
    },
    filterTournaments: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '0',
      );
    },
    filterTournamentsOne: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '1',
      );
    },
    filterTournamentsTwo: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '2',
      );
    },
    filterTournamentsThree: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '3'
      );
    },
    filterTournamentsFour: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '4'
      );
    },
    
    filterReport: function() {
      if (Array.isArray(this.reports)) {
        return this.reports.filter(
          (reports_entry) =>
            reports_entry.report_title.includes("Tournament Entries") ||
            // reports_entry.report_title == 'Round 1 Draw' ||
            reports_entry.report_title.includes("Score") ||
            // reports_entry.report_title.includes("Live") ||
            reports_entry.report_title.includes("Final")
        );
      } else return this.reports; 
    },

    currentReport() {
      if (Array.isArray(this.filterReport))
        return this.filterReport[this.filterReport.length - 1].report_url;
      else return this.reports.report_url;
    },
    currentTitle() {
      if (Array.isArray(this.filterReport))
        return this.filterReport[this.filterReport.length - 1].report_title;
      else return this.reports.report_title;
    },
    reportTitle: function(url) {
        let class_api = ''
        if (this.class_api == 'snr') {
          class_api = 'snr';
        } else {
          class_api = this.class_apiwpg;
        }
        if (this.currentReport.indexOf("tmentry") !== -1) {
          url =
            this.config.VUE_APP_TIC_BASE +
            class_api +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-entryw-entries.json?Ausrandomadd=" +
            new Date().getTime();
        } else {
          if (this.currentReport.indexOf("tmscore") !== -1) {
            var subRep3 = this.currentReport.lastIndexOf("params=") + 7;
            var indNext3 = this.currentReport.indexOf("~", subRep3);
            var repParams1 = this.currentReport.substr(
              subRep3,
              indNext3 - subRep3
            );
            if (repParams1 && repParams1.indexOf(".cgi") < 0) {
              url =
                this.config.VUE_APP_TIC_BASE +
                class_api +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                // this.course +
                this.course +
                "-scores-" +
                repParams1 +
                ".json" +
                "?randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/" + "dev" + "/cache/" + "dev" + "/" + "215S" + "/" + "215S" + "-" + "AUS7" + "-scores-" + $scope.repParams + ".json"+"?randomadd=1603894106415";
            } else {
              url =
                this.config.VUE_APP_TIC_BASE +
                class_api  +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
            }
          } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
            {
              url =
                this.config.VUE_APP_TIC_BASE +
                class_api  +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
            }
          } else if (this.currentReport.indexOf("tmdraw") !== -1) {
            var subRep6 = this.currentReport.lastIndexOf("round=") + 6;
            var indNext6 = this.currentReport.indexOf("~", subRep6);
            var drawRnd6 = this.currentReport.substr(subRep6, indNext6 - subRep6);
            url =
              this.config.VUE_APP_TIC_BASE +
              class_api  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-draw-R" +
              drawRnd6 +
              "-draw.json" +
              "?randomadd=" +
              new Date().getTime();
          } else if (this.currentReport.indexOf("tmresult") !== -1) {
            var subRep5 = this.currentReport.lastIndexOf("result=") + 7;
            var indNext5 = this.currentReport.indexOf("~", subRep5);
            var resNum5 = this.currentReport.substr(subRep5, indNext5 - subRep5);
            console.log("resNum === ");
            console.log(resNum5);
            url =
              this.config.VUE_APP_TIC_BASE +
              class_api  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-" +
              'PF' +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              this.config.VUE_APP_TIC_BASE +
              class_api  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-PF.json" +
              "?randomadd=" +
              new Date().getTime();
          }
        }
      return url;
    },
  },
  //  metaInfo() {
  //    //Injects Meta and Title to Head
  //    return {
  //      title: this.title.content,
  //      meta: [
  //        {
  //          name: this.description.name,
  //          content: this.description.content
  //        }
  //      ]
  //    };
  //  },
  created() {
    localStorage.clear();
    // this.myFunction();
    // window.addEventListener('resize', this.myFunction);
    setInterval(
      console.log('In Interval 270'),
      this.updateSize, 12000,
      console.log('In Interval 272')
    );
    // this.getAllTourns();
    this.reportListText();
    // this.getReports(current);
  },
};
</script>
<style scoped>
::v-deep .dropdown.b-dropdown.mobileDropdown.btn-group {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  vertical-align: middle;
  border: 0px solid #ced4da;
  border-radius: 0.25rem;
  color: #495057;
}
::v-deep .dropdown.b-dropdown.mobileDropdown.btn-group > button {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
  text-align: left;
}
::v-deep .dropdown-toggle::after {
  text-align: right;
  float: right;
  position: relative;
  top: 10px;
}
::v-deep ul.dropdown-menu.show {
  width: 100%;
}
::v-deep .dropdown-item {
  color: #000!important;
}
option.showNone {
  display: none;
}
.suspendBkColor {
  background-color: blue!important;
}
.suspend {
  position: absolute;
  bottom: 0!important;
  background: red!important;
  width: 100%!important;
  text-align: center;
  color: #fff;
  padding-left: 20px;
  padding-right: 23px;
}
::v-deep option.opt-arrow.showNone {
  display: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
}
.RolexSection {
  margin-top: 6px;
}
.colClass {
  padding: 0!important;
}
.LiveScoreMessage {
  position: absolute;
  /* bottom: 66px; */
  bottom: 0px;
  background: red;
  width: 93%;
  text-align: center;
  color: #fff;
  /* white-space: nowrap; */
  /* overflow: hidden; */
  padding-left: 20px;
  padding-right: 23px;
}
.mobStyleWid {
  width: 100%!important;
  bottom: 2px!important;
}
.LiveScoreMessage > p {
  margin-bottom: 0;
  padding-top: 10px;
  padding-bottom: 10px;
}
.TournDrop {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
}
::v-deep li.nav-item.tabsStyle.tabWidth {
  width: 50%;
}
::v-deep .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: transparent;
}
::v-deep .tabone {
  width: 27%;
}
::v-deep .tabtwo {
  width: 40%;
}
::v-deep .tabthree {
  width: 33%;
}
.homeHeight {
  /* height: 669px; */
  /* height: 605px; */
  height: 589px;
}
.HomehomeReport-list {
  border: 1px solid #E6E6E6;
}
::v-deep li.nav-item.tabsStyle {
  /* width: 33%; */
}
::v-deep li.nav-item.tabsStyle > a{
  /* padding-left: 13px!important;
  padding-right: 10px!important; */
}
::v-deep .nav-tabs .nav-link:hover {
  cursor: default;
  background-color: #dfe1e6;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 13px;
  color: #00433e !important;
  padding-left: 18px;
  padding-right: 20px;
  text-align: center;
}
::v-deep .nav-tabs .nav-link.active {
  cursor: default;
  background-color: #fff;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  color: #34caa9 !important;
  padding-left: 18px;
  padding-right: 20px;
  border-bottom: 0px solid #dee2e6;
  padding-top: 14px;
  padding-bottom: 35px;
  border: none!important;
}
::v-deep .nav-tabs .nav-link {
  cursor: default;
  background-color: #E6E6E6;
  color: #B8B8B8 !important;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  padding-left: 18px;
  padding-right: 20px;
  border-bottom: 0px solid #dee2e6;
  text-align: center;
  padding-top: 14px;
  padding-bottom: 35px;
  border: none!important;
}
::v-deep .nav-tabs {
    border-bottom: 0px solid #dee2e6;
}
/* ::v-deep .tabWhite { 
  padding-top: 0em;
  height: 581px;
} */
.home {
  background-color: #fff;
}
.title {
  font-weight: 500;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  color: #000;
  font-size: 23pt;
  margin-top: 1em;
  line-height: 1.1;
  /* letter-spacing: 2px; */
}

.ad {
  padding: 15px 0; 
}

.bottomAdBanner {
  width: 100%;
}
.sections {
  padding: 30px 0;
}
.box {
  display: block;
  top: 0px;
  border-radius: 4px;
  position: relative;
  text-decoration: none;
  z-index: 0;
  overflow: hidden;
}

.box:hover {
  transition: all 0.3s ease;
  box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
  top: -4px;
  background-color: white;
}
@media only screen and (max-height: 1024px) {
  .homeReport-list {
    /* height: auto !important; */
  }
}

@media only screen and (max-height: 990px) {
  ::v-deep option.opt-arrow.showNone {
    display: block;
    -webkit-appearance: block;
    -moz-appearance: block;
    -o-appearance: block;
    appearance: block;
  }
}
@media only screen and (min-height: 501px) {
  .homeContainer.container {
    padding-left: 0px!important;
    padding-right: 0px!important;
  }
  ::v-deep option.opt-arrow.showNone {
    display: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
  }
}
@media only screen and (max-height: 500px) {
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px!important;
  }
}
@media only screen and (max-height: 430px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    color: #34caa9 !important;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    padding-top: 15px;
    padding-bottom: 35px;
    border: none!important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    padding-top: 15px;
    padding-bottom: 35px;
    border: none!important;
  }
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px!important;
  }
}
.mobWidgetPad {
  height: 476px!important;
}


@media only screen and (max-width: 480px) {
  .bottomAdBanner{
    padding: 15px 0;
  }
  .hero-plus__html-content iframe {
    width: 94%!important;
    height: 980px!important;
  }
}

@media only screen and (max-width: 419px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 13px;
    color: #34caa9 !important;
    padding-left: 5px;
    padding-right: 5px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 13px;
    padding-left: 5px;
    padding-right: 5px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
  }
}

@media only screen and (max-width: 400px) {
  ::v-deep option.hideMobNow {
    display: none!important;
  }
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #34caa9 !important;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link:hover {
    cursor: default;
    background-color: #dfe1e6;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #00433e !important;
    padding-left: 18px;
    padding-right: 20px;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
}
@media only screen and (max-width: 321px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #34caa9 !important;
    padding-left: 10px;
    padding-right: 15px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    padding-left: 10px;
    padding-right: 15px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link:hover {
    cursor: default;
    background-color: #dfe1e6;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #00433e !important;
    padding-left: 10px;
    padding-right: 15px;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
}
@media only screen and (max-width: 375px) {
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px;
  }
}
</style>
